module.exports = __webpack_public_path__ + "images/exhibitionist-923c193d2115e47fbbc5ee6f3df40ac0.png";